import React, { useState, useEffect, useRef } from 'react';
import { Button, notification } from 'antd';
import { Modal } from '_src/components';
import { Input } from '_src/shared/form-helpers';
import { useSave } from 'store';
import services from '_src/services';

import { ModalContent, FormRow, Label } from '../styles';

const laptopConfig = services['laptopLending'];

export default function RetireLaptopModal({
  visible,
  onClose,
  laptop,
  onRetired
}) {
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const laptopRef = useRef(null);

  useEffect(() => {
    if (visible && laptop) {
      laptopRef.current = laptop;
      setReason('');
    }
  }, [visible, laptop]);

  const currentLaptop = laptopRef.current;

  const { save: retireLaptop } = useSave(laptopConfig.retireLaptop);

  const handleRetire = async () => {
    if (!currentLaptop?.id) {
      notification.error({ message: 'Invalid laptop selected', duration: 3 });
      return;
    }

    if (!reason.trim()) {
      notification.warning({ message: 'Please provide a reason for retiring the laptop', duration: 3 });
      return;
    }

    setSaving(true);

    const response = await retireLaptop({
      laptopId: currentLaptop.id,
      retired_reason: reason
    });

    setSaving(false);

    if (response?.success === 1) {
      notification.success({ message: 'Laptop retired successfully', duration: 5 });
      setReason('');
      laptopRef.current = null;
      onRetired();
      onClose();
    } else {
      notification.error({
        message: response?.data?.message || 'Failed to retire laptop',
        duration: 5
      });
    }
  };

  const laptopName = `${currentLaptop?.brand || ''} ${currentLaptop?.model || ''}`.trim();
  const serialNumber = currentLaptop?.serialNumber || currentLaptop?.serial_number || '';

  return (
    <Modal
      title="Retire Laptop"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="retire" type="danger" onClick={handleRetire} loading={saving}>
          Retire Laptop
        </Button>
      ]}
      width={500}
    >
      <ModalContent>
        <div style={{ marginBottom: 20, padding: 15, background: '#fff7e6', borderRadius: 4, border: '1px solid #ffd591' }}>
          <strong>Warning:</strong> Retiring a laptop will mark it as permanently out of service.
          This action should only be used for laptops that are no longer usable.
        </div>

        <FormRow>
          <Label>Laptop</Label>
          <div style={{ padding: '8px 12px', background: '#f5f5f5', borderRadius: 4 }}>
            {laptopName} {serialNumber && `(${serialNumber})`}
          </div>
        </FormRow>

        <FormRow>
          <Label>Reason for Retirement *</Label>
          <Input
            name="reason"
            placeholder="e.g., Hardware failure, Beyond repair, Lost/Stolen..."
            value={reason}
            onChange={value => setReason(value)}
          />
        </FormRow>
      </ModalContent>
    </Modal>
  );
}
